import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import ToggleSwitch from '../../FormStyles/ToggleSwitch.jsx';
import Text from '../../Text';

import { isRestrictedSiteAdmin, isSiteAdmin } from '../../../lib/utils/roles';

const TileSettings = ({ isSharable, isPublic, handleChange }) => {
  const { t } = useTranslation('tileForm');
  const { userType } = useSelector(state => state.currentUser);

  return (
    <Wrapper>
      <Text variant="h7">{t('tileSettigns.title')}</Text>
      <ToggleWrapper>
        <Text as="label" htmlFor="isSharable">
          {t('tileSettigns.sharingWithFamily')}
        </Text>
        <ToggleSwitch
          label={t('tileSettigns.switchLabel')}
          value={isSharable}
          onChange={handleChange}
          name="isSharable"
          id="isSharable"
        />
      </ToggleWrapper>
      {(isSiteAdmin(userType) || isRestrictedSiteAdmin(userType)) && (
        <ToggleWrapper>
          <Text as="label" htmlFor="isPublic">
            {t('tileSettigns.addToExploreLabel')}
          </Text>
          <ToggleSwitch
            label={t('tileSettigns.switchLabel')}
            value={isPublic}
            onChange={handleChange}
            name="isPublic"
            id="isPublic"
          />
        </ToggleWrapper>
      )}
    </Wrapper>
  );
};

export default TileSettings;

const Wrapper = styled.div`
  padding: 16px 0;
`;

const ToggleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 16px 0;
`;
